import Phaser from 'phaser';


export default class GetList{

    constructor(){
        GAME_REF.obj.getList = this;

        this.scene = GAME_REF.scene;
        this.manager = GAME_REF.obj.manager;

        this.container = null;
        this.items = [];

        this._init();
    }


    addItem(frameNo){
        this._checkMax();
        this._createDragon(frameNo);
    }


    _init(){
        this._create();
    }


    _checkMax(){
        if(this.items.length < 7) return;

        const firstItem = this.items[0];
        this.scene.tweens.add({
            targets: firstItem,
            alpha: 1,
            scaleX: 0.8,
            scaleY: 0.8,
            duration: 150,
            ease: 'Cubic.easeOut',
            onComplete:()=>{
                firstItem.destroy();
            }
        });

        for(let i=1; i<this.items.length; i++){
            this.scene.tweens.add({
                targets: this.items[i],
                x: '-=140',
                duration: 300,
                delay: 100,
                ease: 'Cubic.easeOut'
            });
        }

        this.items.shift();
    }


    _create(){
        this.container = this.scene.add.container(127, 13);
        
        const color = Phaser.Display.Color.GetColor(0, 0, 0);
        const bg = this.scene.add.graphics({fillStyle: {color}});
        bg.fillRoundedRect(0, 0, 1024, 104, 52);
        bg.alpha = 0.5;
        this.container.add(bg);
    }


    _createDragon(frameNo){
        const x = this.items.length * 140 + 90;
        const dragon = this.scene.add.sprite(x, 48, 'get_dragon_s');
        dragon.alpha = 0;
        dragon.setScale(1.1);
        this.container.add(dragon);
        dragon.setFrame(frameNo);
        this.items.push(dragon);

        this.scene.tweens.add({
            targets: dragon,
            alpha: 1,
            scaleX: 1,
            scaleY: 1,
            duration: 700,
            delay:500,
            ease: 'Cubic.easeOut',
            onStart:()=>{
                GAME_REF.obj.sound.playOne('se_failed');
            }
        });
    }
}